<template>
  <!-- Modal -->
  <div
    v-if="show ===true" 
    id="exampleModalCenter"
    class="modal fade show"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalCenterTitle"
    aria-hidden="true"
    style="display: block; opacity: 1"
  >
    <div
      class="modal-dialog modal-dialog-centered"
      :class="popupSize"
      role="document"
    >
      <div class="modal-content">
        <div
          v-if="header"
          class="modal-header"
        >
          <h5
            id="exampleModalLongTitle"
            class="modal-title"
          >
            {{ title }}
          </h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
            @click.prevent="fn_closeComfirmPop()"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <slot name="body" />
        </div>
        <div class="modal-footer">
          <slot name="footer" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import '../assets/scss/main.scss'
  import store from "@/store";
  export default {
    name: 'ComfirmModalApp',
    props:{
      title: {
        type: String,
        default: ''
      },
      show :{
        type: Boolean,
        default: false
      },
      header: {
        type: Boolean,
        default: false
      },
      price: {
        type: String,
        default: '0.00'
      },
      popupSize :{
        type: String,
        default: ''
      },
    },
    data() {
      return {
            
      }
    },
    computed: {
      order_items(){
        return store.getters['items/order_items'];
      }
    },
    mounted() {
    },
    methods: {
      fn_closeComfirmPop(){
          this.$store.dispatch('popup/updateComfirmPopAction',false)
      },
    },

  }
</script>
<style lang="scss" scoped>
.modal-content .modal-footer button{
  width: 90px;
  margin: 0 10px;
}
.modal-footer {
  display: block;
  margin: auto;
}
.btn-yes {
    background: rgb(136, 160, 136);
    border: 1px solid white;
    margin-right: 50px
}
.btn-no {
  background: #a8ada8;
  border: 1px solid #f3f0f0;
}
.btn-yes, .btn-no{
    width: 90px;
    float: right;
    margin-left: 50px;
    border-radius: 999px;
}
.button-footer > .btn-no {
  margin-right: 50px;
}
.con-confrim-order{
  position: block;
  margin: auto;
}
.scroll-printing-area {
  margin: auto;
  height: 40vh;
  width: 100%;
}
.btn-cancel-payment,.btn-payment,.btn-printing{
  height: 40px;
}
.btn-yes,.btn-no {
  height: 50px;
    width: 100px;
}
.btn-payment {
  width: 110px;
  margin-right: 50px;
  border-radius: 999px;
  background: #4c5840;
  color: #fff;

}
.btn-cancel-payment {
  width: 110px;
  margin-left: 50px;
  border-radius: 999px;
  background: #552626;
  color: #fff;
}
.btn-printing{
  float: right;
  width: 110px;
  margin-left: 50px;
  border-radius: 999px;
  background: #0a2f3d;
  color: #fff;
}
</style>